<template>
  <div class="team-members-list">
    <h6>Team members</h6>
    <div class="team-members-avatars mt-3">
      <div
        v-for="(member, index) in members"
        :key="member.member"
        :class="{ 'team-members-selected': selectedIndex === index }"
        @click="onMemberClick(member.profile, index)"
      >
        <avatar :src="member.profile.photo" size="2.2rem" />
      </div>
    </div>
    <div v-if="selectedProfile" class="team-members-content mt-4">
      <team-members-item
        :profile="selectedProfile"
        :me="profileMe.id===selectedProfile.id"
        :user-kudos="selectedUserKudos"
        :user-thanks="selectedUserThanks"
        @give-kudo="$emit('give-kudo', $event)"
        @send-message="$emit('send-message', $event)"
      />
    </div>
  </div>
</template>

<script>
import TeamMembersItem from './TeamMembersItem.vue'
import Avatar from '@/components/common/Avatar'
import { userName } from '@/helpers/helpers'

export default {
  name: 'TeamMembersList',

  props: {
    team: {
      type: Object,
      required: true
    },

    profiles: {
      type: Object,
      required: true
    },

    profileMe: {
      type: Object,
      required: true
    },

    userKudos: {
      type: Object
    },

    userThanks: {
      type: Object
    }
  },

  watch: {
    team(value) {
      if (this.members.length > 0) {
        this.selectMember(0)
      }
    }
  },

  data() {
    return {
      selectedIndex: null
    }
  },

  mounted() {
    if (this.members.length > 0) {
      this.selectMember(0)
    }
  },

  computed: {
    members() {
      return (this.team.members || []).map(member => ({
        ...member,
        profile: this.profiles[member.profile] || {}
      }))
    },

    isCorrectSelectedIndex() {
      return this.selectedIndex !== null && this.members.length > 0 && this.selectedIndex < this.members.length
    },

    selectedProfile() {
      return this.isCorrectSelectedIndex
        ? this.members[this.selectedIndex].profile
        : null
    },

    selectedUserKudos() {
      return this.isCorrectSelectedIndex ? this.userKudos[this.members[this.selectedIndex].profile.id] : {}
    },

    selectedUserThanks() {
      return this.isCorrectSelectedIndex ? this.userThanks[this.members[this.selectedIndex].profile.id] : {}
    }
  },

  methods: {
    userName(profile) {
      return userName(profile)
    },

    selectMember(index) {
      if (this.selectedIndex !== index) {
        this.selectedIndex = index
        this.$emit('select', this.members[index].profile)
      }
    },

    onMemberClick(profile, index) {
      this.selectMember(index)
    }
  },

  components: {
    Avatar,
    TeamMembersItem
  }
}
</script>
